import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'poster-editor-item-shadow-panel';

export default function PosterEditorItemShadowModal(): ReactElement<any> {
  const [height, setHeight] = useState('182px');
  const sizeData = useAppSelector((state) => {
    return state.panels.sizeDataHashmap[PANEL_ID];
  });
  const panelProperties = useAppSelector((state) => {
    return state.panels.panelPropertiesHashmap[PANEL_ID];
  });

  useEffect((): void => {
    if (sizeData?.height) {
      setHeight(sizeData.height);
    }
  }, [sizeData]);

  const maxWidth = '800px';

  return (
    <Modal
      doesBottomSheetHaveSnapPoints={panelProperties?.hasSnapPoints}
      snapPointsForBottomSheet={panelProperties?.snapPointsForBottomSheet}
      modalId={MODALS_IDS.POSTER_EDITOR_ITEM_SHADOW_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="poster-editor-item-shadow-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorShadowModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_ITEM_SHADOW_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
